import { useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import { QADashboard } from "./quality-assurance";
import styles from "./QualityAssurance.module.css";

const QualityAssurance = () => {
    const { isDarkMode } = useTheme();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'Quality Assurance';
    }, []);

    // Extract current section from pathname for breadcrumb
    const getBreadcrumbItems = () => {
        const path = location.pathname;
        if (path === '/quality-assurance') return ['Quality Assurance'];
        if (path === '/quality-assurance/validate') return ['Quality Assurance', 'Validate'];
        if (path === '/quality-assurance/approve') return ['Quality Assurance', 'Approve'];
        if (path === '/quality-assurance/analyst-capability') return ['Quality Assurance', 'Analyst Capability'];
        if (path === '/quality-assurance/inquiries') return ['Quality Assurance', 'Inquiries'];
        return ['Quality Assurance'];
    };

    const breadcrumbItems = getBreadcrumbItems();
    const isOnDashboard = location.pathname === '/quality-assurance';

    return (
        <div className={styles.qualityAssurance}>
            <div className={styles.header}>
                <h1>Quality Assurance</h1>
                <nav className={styles.breadcrumb}>
                    {breadcrumbItems.map((item, index) => (
                        <span key={index}>
                            {index === 0 ? (
                                <button 
                                    className={`${styles.breadcrumbItem} ${isOnDashboard ? styles.active : ''}`}
                                    onClick={() => navigate('/quality-assurance')}
                                >
                                    {item}
                                </button>
                            ) : index === breadcrumbItems.length - 1 ? (
                                <span className={`${styles.breadcrumbItem} ${styles.active}`}>
                                    {item}
                                </span>
                            ) : (
                                <button 
                                    className={styles.breadcrumbItem}
                                    onClick={() => {
                                        // Add navigation logic for other sections
                                    }}
                                >
                                    {item}
                                </button>
                            )}
                            {index < breadcrumbItems.length - 1 && (
                                <span className={styles.breadcrumbSeparator}>›</span>
                            )}
                        </span>
                    ))}
                </nav>
            </div>

            <div className={styles.content}>
                <Routes>
                    <Route index element={<QADashboard />} />
                    {/* Add more routes as needed */}
                </Routes>
            </div>
        </div>
    );
};

export default QualityAssurance;
